import { ScopeHooks } from "sockapi/scope-specs";
import { getTeamScopeIdComponents } from "sockapi/scope-specs-util";
import { ScopeType } from "sockapi/scope-types";
import { ScopeTeamIdentifier } from "sockapi/scopes";

export type CollectibleMetadata = {
  name: string;
  nounPrefix: string;
  icon: string;
  isHiddenFromTeamName?: true;
};

export type CollectibleState = {
  num: number;
  timestamp: number;
};

export type SockAPITeamCollectibleState = CollectibleMetadata &
  CollectibleState;

type SockAPITeamCollectiblesState = {
  collectibles: {
    [collectibleId: string]: SockAPITeamCollectibleState;
  };
};

export const getTeamCollectibleIcons = (
  { collectibles }: SockAPITeamCollectiblesState,
  /**
   * The hunt end time, to filter out posthunt collectibles.
   * Leave null to include posthunt collectibles.
   */
  huntEndTime: number | null
): string => {
  return Object.values(collectibles)
    .filter(
      ({ isHiddenFromTeamName = false, timestamp }) =>
        !isHiddenFromTeamName &&
        (huntEndTime === null || timestamp < huntEndTime)
    )
    .sort(
      (collectibleData1, collectibleData2) =>
        collectibleData1.timestamp - collectibleData2.timestamp
    )
    .map(({ icon }) => icon)
    .join("");
};

export type TeamCollectiblesScopeSpec = {
  identifier: ScopeTeamIdentifier;
  state: SockAPITeamCollectiblesState;
  /**
   * For simplicity, send over the entire collectible metadata
   * with each update so we don't have to track which collectibles
   * clients have seen.
   */
  update: SockAPITeamCollectiblesState;
};

export const teamCollectiblesScopeHooks: ScopeHooks<ScopeType.TEAM_COLLECTIBLES> =
  {
    identityFunc: (scope) => scope,
    getIdComponents: getTeamScopeIdComponents,
    update: (scopeState, payload) => {
      const { collectibles } = payload;
      for (const [collectibleId, collectibleData] of Object.entries(
        collectibles ?? {}
      )) {
        scopeState.collectibles[collectibleId] = collectibleData;
      }
    },
  };
